import { ParkType, ParkUpdateType } from "Type/park.type";

/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Utils\car.utils.ts
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Friday March 29th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 29th 2024 4:41:51 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */
export function findClosestValueName (valueName: string) {
    var closestValueName = "";
    switch(valueName) {
        case "myStartPrice":
            closestValueName = "StartPrice";
            break;
        case "myPriceSeller":
            closestValueName = "MinSellerPrice";
            break;
        case "myPriceBuyNow":
            closestValueName = "SellPrice";
            break;
        case "myPriceAutoBuy":
            closestValueName = "MinAutobuyPrice";
            break;
        case "myPriceFees":
            closestValueName = "Cost";
            break;
        case "myInspectionURL":
            closestValueName = "Report1";
            break;
        case "myInspectionURL2":
            closestValueName = "Report2";
            break;
        case "myMaintenanceURL":
            closestValueName = "Maintenance";
            break;
        case "myPicURL":
            closestValueName = "Report2";
            break;
        }
    return closestValueName;
};

export function ConvertParkToString (StoragePlace: ParkUpdateType) {
    let myCustomPark = "NC";
    if (StoragePlace.Name && StoragePlace.Name !== "")
        myCustomPark = StoragePlace.Name;
    else if (StoragePlace.City && StoragePlace.City !== "")
        myCustomPark = StoragePlace.City;
    else if (StoragePlace.PostalCode && StoragePlace.PostalCode !== "")
        myCustomPark = StoragePlace.PostalCode;
    else if (StoragePlace.Country && StoragePlace.Country !== "")
        myCustomPark = StoragePlace.Country;
    else
        myCustomPark = [StoragePlace.Name, StoragePlace.Address, StoragePlace.State, StoragePlace.PostalCode, StoragePlace.City, StoragePlace.Country ].join(" ");
    return myCustomPark;
};
